(function (window, $) {
	window.app.register('orderForm', function ($el, options) {
		var self = this;

		self.$form = $el;
		self.options = options;

		$.nette.ext('live').after(function($el) {
			$el.find('[data-app-delivery-method-change]').on('change', function (e) {
				$(this).closest('form').find('[name="redrawOnDeliveryMethodChange"]').netteAjax(e).done(function () {
					if ($('[name=deliveryMethod]').val() in self.options.deliveryMethodsWithPlaces) {
						$('select[name="parcelPointExternalId"]').select2({
							width: '100%'
						});
					}
				});
			});
		});

		$(document).on('change', '[name="paymentMethod"]', function (e) {
			$(this).closest('form').find('[name="redrawSummary"]').netteAjax(e);
		});

		// Přepočet ceny po změně PSČ. Čeká se na dopsání, ať se na API neklepe po číslici.
		var zipTimeout = null;
		$(document).on('input', '[name="zip"], [name="deliveryZip"]', function (e) {
			var $form = $(this).closest('form');
			clearTimeout(zipTimeout);
			zipTimeout = setTimeout(function () {
				$form.find('[name="redrawOnZipChange"]').netteAjax(e);
			}, 600);
		});

        // automatické doplňování (z "Vaše údaje" se propisuje do doručovacích)

		self.$form.find('[name="firstName"]').on('keyup', function () {
			$('[name="deliveryFirstName"]').val(this.value);
		});

		self.$form.find('[name="lastName"]').on('keyup', function () {
			$('[name="deliveryLastName"]').val(this.value);
		});

		self.$form.find('[name="phoneCountryCode"]').on('keyup', function () {
			$('[name="deliveryPhoneCountryCode"]').val(this.value);
		});

		self.$form.find('[name="phoneNationalNumber"]').on('keyup', function () {
			$('[name="deliveryPhoneNationalNumber"]').val(this.value);
		});

        // Obarvovani aktivnich řádků podle výběru radio buttonů
        $(".radio-label").click(function(e) {
            if ($(this).hasClass('delivery-label')) {
                $('.delivery-row.active-table-row').removeClass('active-table-row');
                $(this).closest('.delivery-row').addClass('active-table-row');

            } else if ($(this).hasClass('payment-label')) {
                $('.payment-row.active-table-row').removeClass('active-table-row');
                $(this).closest('.payment-row').addClass('active-table-row');

            } else if ($(this).hasClass('card-label')) {
                $('.tr-order-images.active-table-row').removeClass('active-table-row');
                $(this).closest('.tr-order-images').addClass('active-table-row');
            }
        });

        // orderForm specific

		$(document).on('click', '#frm-orderForm-form-oneKeratinButton, #frm-orderForm-form-twoKeratinsButton', function(e) {
			e.preventDefault();
			$(this).netteAjax(e).done(function(payload) {
				$('.order-content').removeClass('hidden'); // zobrazování obsahu formuláře až po kliknutí na "VYBRAT" u obrázků objednávky
				$('.single-keratin').css('background-color', 'rgb(255,255,255,0.1)').css('border-color', '#cfba81');
				$('.double-keratin').css('background-color', 'transparent');
				$('html, body').animate({
					scrollTop: $("#scroll-point").offset().top
				}, 1000);
			});
		});

		// Kontrola DPH u jinych zemi nez zemi e-shopu
		function checkVatPayer() {
			const $country = $('#frm-newOrderForm-form-country'),
				$deliverToAnotherAddress = $('#frm-newOrderForm-form-deliverToAnotherAddress'),
				$deliveryCountry = $('#frm-newOrderForm-form-deliveryCountry'),
				$businessPurchase = $('#frm-newOrderForm-form-businessPurchase'),
				$vatin = $('#frm-newOrderForm-form-vatin'),
				$vatPayer = $('#vatPayer-div'),
				$checkbox = $vatPayer.find('input[name="vatPayer"]');

			const eshopCountry = String($country.data('eshop-country'));
			const wasChecked = $checkbox.is(':checked');
			let foreignCountry = false;

			if ($businessPurchase.is(':checked')) {
				// pokud existuje dorucovaci adresa a je zapnuta, tak pouzijeme dorucovani zemi
				const c = ($deliverToAnotherAddress.length && $deliverToAnotherAddress.is(':checked'))
					? $deliveryCountry.val()
					: $country.val();

				foreignCountry = c !== eshopCountry;
			}

			$vatPayer.toggle(foreignCountry);

			// vyplněné DIČ u zahraniční země = plátce DPH
			const checked = foreignCountry && ($vatin.val() || '').trim() !== '';
			$checkbox.prop('checked', checked);
			if (checked !== wasChecked) {
				$checkbox.trigger('change');
			}
		}

		$(document).on('change', '#frm-newOrderForm-form-country, #frm-newOrderForm-form-deliverToAnotherAddress, #frm-newOrderForm-form-deliveryCountry, #frm-newOrderForm-form-businessPurchase, #frm-newOrderForm-form-vatin', checkVatPayer);

		checkVatPayer();
	}, {
		availableCommands: [

		],
	});
}(window, jQuery));